module.exports = __webpack_public_path__ + "img/minions1.04c2d4f1.jpg";